import { FC } from "react"
import { Tooltip, Typography } from "@mui/material"
import { useClientQuery } from "../../store"
import { useClientsLookup } from "../../hooks"
import { ClientIdentity } from "./clientIdentity"
import { shortId } from "./identityFormat"

export interface IdentityResolverCellProps {
  clientId: string | null | undefined
  compact?: boolean
  emptyFallback?: string
}

export const IdentityResolverCell: FC<IdentityResolverCellProps> = ({
  clientId,
  compact = false,
  emptyFallback = "—",
}) => {
  const { getClient } = useClientsLookup()
  const cached = clientId ? getClient(clientId) : undefined
  const {
    data: fetched,
    isLoading,
    isError,
  } = useClientQuery({ id: clientId ?? "" }, { skip: !clientId || !!cached })

  if (!clientId) {
    return (
      <Typography variant="body2" color="text.secondary">
        {emptyFallback}
      </Typography>
    )
  }

  const client = cached ?? fetched

  if (client) {
    return <ClientIdentity client={client} compact={compact} />
  }

  if (isLoading) {
    return (
      <Typography variant="body2" sx={{ fontFamily: "monospace" }}>
        {shortId(clientId)}
      </Typography>
    )
  }

  if (isError || !client) {
    return (
      <Tooltip title="данные недоступны">
        <Typography
          variant="body2"
          sx={{ fontFamily: "monospace" }}
          color="text.secondary"
        >
          {shortId(clientId)}
        </Typography>
      </Tooltip>
    )
  }

  return null
}
